












































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { PlanApi } from '../api/plan';
import { PlanVm } from '../classes/plan';
import AppMessage from '../../core/models/appMessage';
import { ElForm } from 'element-ui/types/form';
import { CurrentSubscriptionVm } from '../classes/currentSubscription';
import moment, { Moment } from 'moment';
import { ProfileApi } from '../../profile/api/profile';
import { ProfileModel } from '../../profile/classes/profile';

@Component
export default class Plan extends Vue {
  public loading: boolean = false;
  public changingSubscription: boolean = false;
  public plans: PlanVm[] = [];
  public currentSubscription: CurrentSubscriptionVm = {
    subscriptionId: '',
    subscriptionCode: '',
    allowedDevices: 0,
    includedDevices: 0,
    enabledFeatures: [],
    firstSubscription: new Date(),
    subscriptionEndDate: new Date(),
    subscriptionChange: new Date(),
    type: '',
    isCancalled: false,
  };
  public cancelSubModalOpen: boolean = false;
  public cancelSubBtnLoading: boolean = false;
  public showYearly: boolean = false;
  private api: PlanApi;
  private profileApi: ProfileApi;
  private showSubscriptionEndData: boolean = false;
  private showShopifyInformation: boolean = false;
  private profile: ProfileModel;

  constructor() {
    super();
    this.api = new PlanApi();
    this.profileApi = new ProfileApi();
    this.profile = new ProfileModel();
  }

  public async created() {
    this.loadPlans();

    this.profile = await this.profileApi.getProfile();

    await this.loadCurrentSubscription();

    this.showShopifyInformation = this.profile.hadShopifyIntegration;
  }

  public async loadPlans() {
    this.plans = await this.api.getSubscriptions(this.showYearly ? 'Yearly' : 'Monthly');
  }

  public async loadCurrentSubscription() {
    const result = await this.api.getCurrentSubscription();
    if (result) {
      this.currentSubscription = result;

      this.showSubscriptionEndData =
        this.currentSubscription.subscriptionCode !== 'free10' && this.profile.hadShopifyIntegration === false;
    }
    const currentPlan = this.$route.query.currentPlan as string;

    if (currentPlan == null) {
      return;
    }

    if (this.currentSubscription.subscriptionCode !== currentPlan) {
      this.changingSubscription = true;

      setTimeout(() => this.loadCurrentSubscription(), 1000);

    } else {
      this.changingSubscription = false;
      this.$router.push('/plan');
    }
  }

  public formatDateTime(textDate: string) {
    const date = moment(textDate);
    return date.format('DD/MM/YYYY HH:mm');
  }

  public toPayment(subCode: string, duration: string) {
    this.$router.push('/payment?subCode=' + subCode + '&duration=' + duration);
  }

  public async cancelSub() {
    this.cancelSubBtnLoading = true;
    try {
      await this.api.cancelSubscription();
      AppMessage.show(this.$t('plan.subscriptionCancelSuccess'), 'success');

      await this.loadCurrentSubscription();
    } catch (error) {
      AppMessage.show(this.$t('plan.subscriptionCancelError'), 'error');
    }

    this.cancelSubModalOpen = false;
    this.cancelSubBtnLoading = false;
  }

  public async onShowYearlyChanged() {
    this.loadPlans();
  }
}
